import {createSelector} from 'reselect'
import * as Constants from './constants';

const ErrorSelector = state => state.Error.error || {code: Constants.ERROR.DEFAULT_CODE, message: Constants.ERROR.DEFAULT_MESSAGE_ERROR};
export const getError = createSelector(
    ErrorSelector,
    data => data
);